import Grid from '@mui/material/Grid';
import { TableCellSkeleton } from './TableCellSkeleton';
import { pxToRem } from 'src/common/utils/fonts';

export const SkeletonPagination = () => {
  return (
    <Grid
      container
      sx={{ background: ({ palette }) => palette.grey[100], height: pxToRem(44) }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid sx={{ pl: 24, width: pxToRem(48) }}>
        <TableCellSkeleton />
      </Grid>
      <Grid sx={{ width: pxToRem(128) }}>
        <TableCellSkeleton />
      </Grid>
      <Grid sx={{ pr: 24, width: pxToRem(48) }}>
        <TableCellSkeleton />
      </Grid>
    </Grid>
  );
};
